/*
 * Types.
 */

export enum SandboxScenariosEnum {
  SCENARIO3_ACT1 = 'scenario-3-conversation-1',
  /**
   * @deprecated Legacy scenario without AI compose features. Kept for backward compatibility.
   * New code should use SCENARIO3_ACT2_AI_COMPOSE instead.
   */
  SCENARIO3_ACT2 = 'scenario-3-conversation-2',
  SCENARIO3_ACT2_AI_COMPOSE = 'scenario-3-conversation-2-ai-compose',
  SCENARIO3_ACT3 = 'scenario-3-conversation-3',
  SCENARIO4_ACT4 = 'scenario-4-conversation-4', // Replaced scenario-3-conversation-4
  SCENARIO5_ACT1 = 'scenario-5-conversation-1',
}
